import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { getLanguage } from "../../utils"

const StyledBackLinkContainer = styled.div`
  padding: 1rem 0;
`

const StyledBackLink = styled(props => <Link {...props} />)`
  color: ${props => props.theme.crockpot.text};
  font-family: ${props => props.theme.crockpot.mainFont};
  font-size: 1.2rem;
  text-decoration: none;
  text-transform: uppercase;
  transition: 200ms linear;

  @media (min-width: 769px) {
    font-size: 1.8rem;

    &:hover {
      color: ${props => props.theme.crockpot.text};
      font-weight: bold;
    }
  }

  span {
    &:first-letter {
      text-transform: uppercase;
    }
  }
`

const BackLink = ({ title, link }) => {
  return (
    <StyledBackLinkContainer>
      <StyledBackLink to={`${getLanguage()}/${link}`} aria-label={`< ${title}`}>
        {`<`} <span>{`${title}`}</span>
      </StyledBackLink>
    </StyledBackLinkContainer>
  )
}

BackLink.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
}

BackLink.defaultProps = {
  title: ``,
  link: ``,
}

export default BackLink
